import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import dcautocomplete from "./../Shared/dcautocomplete.vue";
import { MesDriversMenuOS2, HidElem } from "./../ServiceDrivers/driversstruct";
import { createPinia } from 'pinia';

let gpage: number;
let  gvendorid: number;
let gcategorie: number;
let gnummatos: number;
let glastpage: number;
let glancurrent: string;
gpage = 1;
glastpage = 1;
gvendorid = 0;
gcategorie = 0;
gnummatos = 0;
glancurrent = "fr";
 enum mcdriverscategories { UNDEFINED = 0, AUDIO = 1, CAMERA = 2, LECTEUROPTIQUE = 3, MONITOR = 4, NETWORK = 5, GAMECONTROLLER = 6, GRAPHICS = 7, HARDDISKCONTROLLER = 8, KEYBOARD = 9, MODEM = 10, MOTHERBOARD = 11, MOUSE = 12, PRINTER = 13, SCANNER = 14, USB = 15, VIDEO = 16, ONDULEUR = 17, FIREWIRE = 18, BLUETOOTH = 19, SENSORS = 20, BIOMETRIC = 21, OTHER = 22, MULTIMEDIA = 23, CARDREADER = 24, USBCONTROLLER = 25 };

export class DriversListeMatos {
    public  hid: number = 0;
    public  namematos: string = "";
    public  hidname: string = "";
    public category: mcdriverscategories = mcdriverscategories.OTHER;
}

export class dccore_es_hid {
    public idnum: number = 0;
    public matosid: number = 0;
    public constid: number = 0;
    public ismachineid: boolean = false;
    public hid: string = "";
    public bus: number = 0;
    public vid: number = 0;
    public pid: number = 0;
    public subsysid: number = 0;
    public vendorname: string | null = null;
    public devicename: string | null = null;
    public manufacturer: number = 0;
    public category: number = 0;
    public description: string = "";
    public descriptionlower: string = "";
}

interface IDictionaryMatosCat {
    [index:number]: dccore_es_hid[];
}

export class DriversManufacturerViewModel {
    public  m_vendorid: number = 0;
    public  m_vendorname: string = "";
    public m_listematos: DriversListeMatos[] = [];
    public m_matoscat: IDictionaryMatosCat = [];
    public numpages: number = 0;
    public m_page: number = 0;
}

export class DriversHardwareViewApiModel {
    public  m_vendorid: number = 0;
    public  m_vendorname: string = "";
        public  m_categorie: number = 0;
    public  m_urlinstall: string = "";
    public  m_letter: string = "";
    public  m_namematos: string = "";
        public  m_hid: number = 0;
    public  m_hidname: string = "";
    public menuos: MesDriversMenuOS2[] = [];
    public m_resulthids: HidElem[] = [];
     
    }

export class DriversManufacturerCatViewModel extends DriversManufacturerViewModel{
}



const mixin = defineComponent({
    data() {
        return {
            lancurrent:"",
            modelhardwareos:null as DriversHardwareViewApiModel|null,
            nameos: 1,
            matosquery: "",
            constructeurcheck: true,
            vendorid: 0,
            categorie: 0,
            page: 1,
            urlconstructeur: "",
            m_matoscat: [] as IDictionaryMatosCat,
            m_listematos: [] as DriversListeMatos[],
            m_vendorname: "",
            m_urldriversman: "",
            m_urldrivershwdriver: "",
            dcloadingmatos: false,
            nummatos: 0,
            showfirstmatos: true
        };
    },


    mounted() {

        this.page = glastpage + 1;
        this.vendorid = gvendorid;
        this.categorie = gcategorie;
        this.nummatos = gnummatos;
        this.lancurrent = glancurrent;
    },

    created() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    },

    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {

        SetDriversManufacturerCat(url: string) {
            this.m_urldriversman = url;
        },

        SetHardwareDriver(url: string) {
            this.m_urldrivershwdriver = url;
        },

        GetDriversManufacturerCat(id: number, cat: number, page: number, keywords: string): string {
            return this.m_urldriversman.replace("-1", id.toString()).replace("-2", cat.toString()).replace("-3", page.toString()).replace("%keywords%", keywords);
        },

        GetHardwareDriver(id: number, keywords: string): string {
            return this.m_urldrivershwdriver.replace("-1", id.toString()).replace("%keywords%", keywords);
        },

        HardwareOs(lancurrent:string,id: number, os: number) {
            let url = "/api/v1.0/Drivers/HardwareOs?lancurrent=" + lancurrent + "&id=" + id+"&os="+os;
            let self = this;
            axios.get<DriversHardwareViewApiModel>(url).then(function (response: AxiosResponse<DriversHardwareViewApiModel>) {
                if (response.data !== null) {
                    self.modelhardwareos = response.data;
                }
            });
        },

        DriversManufacturer(data: string, vendorid: number) {
            let url = "/api/v1.0/Drivers/DriversManufacturer";
            let self = this;
            axios.post<DriversManufacturerViewModel>(url, { query: data, constructeur: (this.constructeurcheck ? vendorid : 0) }).then(function (response: AxiosResponse<DriversManufacturerViewModel>) {
                if (response.data !== null) {
                    self.m_matoscat = response.data.m_matoscat;
                    self.m_vendorname = response.data.m_vendorname;
                    self.nummatos = response.data.numpages;
                    $("#driverscategories").empty();
                }
            });
        },

        ReloadMatos(lancurrent:string,vendorid: number, data: string, categorie: number, page: number) {
            let self = this;
            self.page = page;
            axios.post<DriversManufacturerCatViewModel>("/api/v1.0/Drivers/ReloadMatos", {lancurrent:lancurrent, query: data, constructeur: (this.constructeurcheck ? vendorid : 0), category: categorie, page: page }).then(function (response: AxiosResponse<DriversManufacturerCatViewModel>) {
                if (response.data !== null) {
                    self.m_listematos = response.data.m_listematos;
                    self.m_vendorname = response.data.m_vendorname;
                    self.nummatos = response.data.numpages;
                    self.page++;
                    self.showfirstmatos = false;

                }
            });
        },



        handleScroll(event: any) {
            let self = this;
            let offset = $('.mc_piedpagebottom').offset();
            if (offset == undefined)
                return;
            let height: number | undefined = $(window).height();
            let scrolltop: number | undefined = $(window).scrollTop();
            if (height === undefined || scrolltop === undefined)
                return;
            if ((offset.top - height <= scrolltop) && this.page <= this.nummatos && !this.dcloadingmatos) {
                this.dcloadingmatos = true;
                var url = "/api/v1.0/Drivers/ReloadMatos";
                axios.post<DriversManufacturerCatViewModel>(url, { lancurrent: self.lancurrent, query: self.matosquery, constructeur: (this.constructeurcheck ? self.vendorid : 0), category: self.categorie, page: self.page }).then(function (response: AxiosResponse<DriversManufacturerCatViewModel>) {
                    if (response !== null && response.data !== null && response.data.m_listematos !== null) {
                        self.m_listematos = self.m_listematos.concat(response.data.m_listematos);
                        self.nummatos = response.data.numpages;
                        self.page++;
                        self.dcloadingmatos = false;
                    }

                });
            }
        },

        SetUrlCategorie(url: string) {
            this.urlconstructeur = url;
        },

        /*SearchConstructeur(url: string, data: string) {
            axios.post<string>(url, { query: data }).then(function (response: AxiosResponse<string>) {
                if (response.data !== null) {
                    $("#blocconst").html(response.data);
                }
            });
        },*/

        ConstructeursResults(input: string) {
            let url: string = "/api/v1.0/drivers/SearchConstructeur?query=" + input;
            return url;
        },

        ConstructeursDisplay(result: any) {
            return result.label;
        },

        ConstructeursSelected(selectitem: any) {
            let url = this.urlconstructeur.replace("-1", selectitem.value).replace("-2", selectitem.display);
            location.href = url;
        },


        ClickSearchMan(event: any, url: string, vendorid: number) {
            event.preventDefault();
            // $('#matosquery').autocomplete("close");
            this.DriversManufacturer(this.matosquery, vendorid);
        },

        searchKeyDownMan(event: any, url: string, vendorid: number) {
            if (event.which === 13) {
                //$('#matosquery').autocomplete("close");
                this.DriversManufacturer(this.matosquery, vendorid);
            }
        },

        ClickSearchManCat(event: any, url: string, vendorid: number, categorie: number) {
            event.preventDefault();
            // $('#matosquery').autocomplete("close");
            this.ReloadMatos(this.lancurrent,vendorid, this.matosquery, categorie, 1);
        },

        searchKeyDownManCat(event: any, url: string, vendorid: number, categorie: number) {
            if (event.which === 13) {
                //$('#matosquery').autocomplete("close");
                this.ReloadMatos(this.lancurrent,vendorid, this.matosquery, categorie, 1);
            }
        },

        ManufacturerResults(input: string) {
            input = input.split("&").join("_and_");
            let url: string = "/api/v1.0/drivers/SearchMatos?query=" + input + "&constructeur=" + ((this.constructeurcheck ? this.vendorid : 0) + "&category=-1");
            return url;
        },

        ManufacturerDisplay(result: any) {
            return result.label;
        },

        ManufacturerSelected(selectitem: any) {
            this.DriversManufacturer(selectitem.display, this.vendorid);
        },

        ManufacturerCatResults(input: string) {
            input = input.split("&").join("_and_");
            let url: string = "/api/v1.0/drivers/SearchMatos?query=" + input + "&constructeur=" + ((this.constructeurcheck ? this.vendorid : 0) + "&category=" + this.categorie);
            return url;
        },

        ManufacturerCatDisplay(result: any) {
            return result.label;
        },

        ManufacturerCatSelected(selectitem: any) {
            this.ReloadMatos(this.lancurrent,this.vendorid, selectitem.display, this.categorie, 1);
        }
    }
});


export class DriversComponent {
    public Init(lancurrent:string,page: number, vendorid: number, categorie: number,nummatos:number,pagenum:number) {
        gpage = page;
        glancurrent = lancurrent;
        glastpage = pagenum;
        gvendorid = vendorid;
        gcategorie = categorie;
        gnummatos = nummatos;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.component("autocomplete", dcautocomplete);
        app.mount('#rootpage');
    }
}
(<any>(window)).DriversComponent = function () { return new DriversComponent(); };